import { useEffect } from 'react';

type ModelContext = {
  registerTool: (
    tool: {
      name: string;
      description: string;
      inputSchema: Record<string, unknown>;
      execute: () => Promise<string>;
      annotations: {
        readOnlyHint: boolean;
        untrustedContentHint: boolean;
      };
    },
    options?: { signal?: AbortSignal },
  ) => Promise<void>;
};

export default function WebMcpTools() {
  useEffect(() => {
    const modelContext = (document as Document & { modelContext?: ModelContext }).modelContext;
    if (!modelContext) return;

    const controller = new AbortController();
    void modelContext.registerTool(
      {
        name: 'get_mynawoo_mcp_connection_options',
        description: 'Get the official public Mynawoo Practice MCP connection details for ChatGPT and Claude. This returns learner MCP details, never Admin MCP credentials.',
        inputSchema: {
          type: 'object',
          properties: {},
          additionalProperties: false,
        },
        execute: async () => JSON.stringify({
          connectorName: 'Mynawoo Practice',
          remoteMcpUrl: 'https://api.mynawoo.com/mcp',
          chatGptUrl: 'https://chatgpt.com/plugins/plugin_asdk_app_6a3096222fc88191a198ee631f044fe5',
          claudeConnectorUrl: 'https://claude.ai/customize/connectors?modal=add-custom-connector&connectorName=Mynawoo+Practice&connectorUrl=https%3A%2F%2Fapi.mynawoo.com%2Fmcp',
        }),
        annotations: {
          readOnlyHint: true,
          untrustedContentHint: false,
        },
      },
      { signal: controller.signal },
    );

    return () => controller.abort();
  }, []);

  return null;
}
